import { render, staticRenderFns } from "./AddressBookForm.vue?vue&type=template&id=65111ba6&"
import script from "./AddressBookForm.vue?vue&type=script&lang=js&"
export * from "./AddressBookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports